import { APP_ROUTES } from "const";
import { useGraphQLGlobalSearch } from "graphql-requests";
import { useDebounce } from "hooks/useDebounce";
import { useUrlQuery } from "hooks/useUrlQuery";
import { useEffect, useState, useRef, useCallback } from "react";
import { useLocation } from "react-router";

export function useSearchBarListener() {
  const [search] = useUrlQuery<{ search: string }>();
  const [isSearchData, setIsSearchData] = useState<boolean | undefined>(false);
  const location = useLocation();

  const searchResult = useGraphQLGlobalSearch(
    search.search?.replace("-", " ") + "*" || "",
    location.pathname === APP_ROUTES.SEARCH_PAGE
  );

  useEffect(() => {
    setIsSearchData(
      searchResult &&
        searchResult.data &&
        (searchResult.data?.investors?.length > 0 ||
          searchResult.data?.organizations?.length > 0 ||
          searchResult.data?.enterpriseUsers?.length > 0)
    );
  }, [searchResult, isSearchData, location.pathname]);
}

export function useInitValues( // on start the app - check query and initialize input state
  setSearchInputValue: (value: React.SetStateAction<string>) => void
) {
  const [params] = useUrlQuery<{ search: string }>();
  useEffect(() => {
    if (params?.search) {
      setSearchInputValue(params?.search);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export function useSearchFieldSetter() {
  const location = useLocation();
  const [, setParams] = useUrlQuery<{ search?: string }>();
  const debouncedSearch = useDebounce(500, (args) => {
    if (location.pathname !== APP_ROUTES.SEARCH_PAGE) {
      setParams((val) => ({ ...val, search: args }), APP_ROUTES.SEARCH_PAGE);
    } else {
      setParams((val) => ({ ...val, search: args }));
    }
  });
  return debouncedSearch;
}

export function useClearSearchField(
  setField: React.Dispatch<React.SetStateAction<string>>
) {
  const location = useLocation();
  const prevLocation = useRef<string>();
  if (
    prevLocation.current === APP_ROUTES.SEARCH_PAGE &&
    location.pathname !== prevLocation.current
  ) {
    setField("");
  }
  prevLocation.current = location.pathname;
}

export function useAskAQuestionModal() {
  const [isAskAQuestionModalShowing, setIsShowing] = useState(false);

  const toggleAskAQuestionModal = useCallback(() => {
    return setIsShowing((state) => !state);
  }, [setIsShowing]);
  return { isAskAQuestionModalShowing, toggleAskAQuestionModal };
}
